import { Client } from '@notionhq/client';

const notion = new Client({ auth: process.env.REACT_APP_NOTION_API_KEY });

const DATABASE_ID = '1ecdbd92f3f580768b70f77e72ede06c'; // Remplacez par l'ID de votre base de données Notion

export const fetchResources = async () => {
  try {
    const response = await notion.databases.query({
      database_id: DATABASE_ID,
    });

    const resources = response.results.map((page) => {
      const pdfFile = page.properties.PDF?.files?.[0]; // Remplacez 'PDF' par le nom de votre propriété de type "Files"
      return {
        id: page.id,
        title: page.properties.Title?.title[0]?.plain_text || 'Sans titre',
        category: page.properties.Category?.select?.name || '',
        content: page.properties.Content?.rich_text[0]?.plain_text || '',
        pdfUrl: pdfFile?.file?.url || '', // URL du fichier PDF
        image: page.properties.Image?.files[0]?.file?.url || '', // Si vous avez une propriété pour une image
        soundcloud: page.properties.Soundcloud?.url || '', // Si vous avez une propriété pour un lien SoundCloud
      };
    });

    return resources;
  } catch (error) {
    console.error('Erreur lors de la récupération des données Notion:', error);
    return [];
  }
};